<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Bina İşlemleri</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="info" @click="SayfaYukle" :disabled="lo">yenile</el-button>
        <el-button size="small" type="primary" @click="BinaModalDurum=true" :disabled="lo">Bina Ekle</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-table
          v-if="Liste"
          class="table-xs table-hover"
          :data="Liste.filter(data => !Kelime || data.adi.toLowerCase().includes(Kelime.toLowerCase()))"
          @current-change="TableSecim"
          :height="Height">
        <el-table-column label="Kod" prop="id" width="75"></el-table-column>
        <el-table-column label="Bina Adı" prop="adi"></el-table-column>
        <el-table-column label="Yönetici" prop="yadi" width="200"></el-table-column>
        <el-table-column label="Bakım Günü" prop="gun" width="100"></el-table-column>
        <el-table-column
            align="right" label="Bolge" prop="Grup" width="250" class-name="tablearama">
          <template slot="header" slot-scope="scope">
            <el-input
                v-model="Kelime"
                size="mini"
                class="tablearamainput"
                placeholder="Arama Yapın"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <BinaModal :Bilgi="null" Tur="Post" :Durum="BinaModalDurum" @Durum="SayfaYukle"></BinaModal>
  </div>
</template>

<script>
import BinaModal from "./Comp/BinaModal";

export default {
  components: {BinaModal},
  data() {
    return {
      lo: false,
      BinaModalDurum: false,
      Kelime: "",
      Height: null,
      Liste: null
    }
  },
  methods: {
    TableSecim(e) {
      this.$router.push('/bina/' + e.id)
    },
    SayfaYukle() {
      this.lo = true
      this.BinaModalDurum = false
      this.$store.dispatch("Get", {path: 'build'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Liste = response.Data
              this.lo = false
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    }
  },
  created() {
    this.$store.dispatch("title", "Bina İşlemleri");
    this.SayfaYukle();
    this.Height = window.innerHeight - 111
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Bina/BinaListe.vue